import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Flex, H1WithBack, PageFooter, PageWrapper, Table, Th, Tr } from 'styling/GlobalStyles'
import { convertToDate, formatDateWithTime, formatNumbersForDisplay, getParams, handlePagination } from 'utils/helpers'
import { clearFuelData, getDispenses } from 'features/fuelManagement/fuelManagementSlice'
import { FilterEnum, IFilter, LinkEnum } from 'components/Filter/SingleFilter'
import { fuelTypes } from './fuelData'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { endOfWeek, startOfWeek } from 'date-fns'

export const FuelDispenses = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const { dispenses } = useSelector((store: RootState) => store.fuelManagement)
    const [params, setParams] = useState<any>(getParams({
        location, ap: {
            dateFrom: searchParams.get('dateFrom') ? new Date(searchParams.get('dateFrom')) : startOfWeek(new Date(), { weekStartsOn: 1 }),
            dateTo: searchParams.get('dateTo') ? new Date(searchParams.get('dateTo')) : endOfWeek(new Date(), { weekStartsOn: 1 }),
        }
    }))

    useQueryPagination({ fetchFunctions: [getDispenses], cleanUpFunctions: [clearFuelData], params })


    const setDateFrom = (value) => {
        setParams(prev => {
            const copy = structuredClone(prev)
            copy.dateFrom = convertToDate(value)
            return copy
        })
    }

    const setDateTo = (value) => {
        setParams(prev => {
            const copy = structuredClone(prev)
            copy.dateTo = convertToDate(value)
            return copy
        })
    }

    const filters: IFilter[] = [
        {
            type: FilterEnum.FIXED_LIST,
            name: 'Fuel Type',
            state: null,
            propName: 'fuelTypeId',
            sd: true,
            single: true,
            filterOptions: fuelTypes.map(s => ({ name: s.label, id: s.value.toString() })),
        },
        {
            type: FilterEnum.ASYNC_SELECT,
            link: LinkEnum.MACHINES,
            name: 'Machine',
            state: null,
            single: true,
            propName: 'machineId'
        }
    ]

    return <>
        <NavBar filterOptions={filters} enableTemporaryManualClosing setParams={setParams} params={params} />
        <PageWrapper>
            <Flex width='100%' between >
                <H1WithBack title='Dispenses' arrow />

                <Flex gap='1rem'>
                    <CalendarInput
                        maxDate={new Date(params.dateTo)}
                        labelText='Start date'
                        defaultValue={new Date(params.dateFrom || new Date())}
                        onChange={v => setDateFrom(v)}
                    />
                    <CalendarInput
                        minDate={new Date(params.dateFrom)}
                        labelText='End date'
                        defaultValue={new Date(params.dateTo || new Date())}
                        onChange={v => setDateTo(v)}
                    />
                </Flex>
            </Flex>
            {!dispenses?.data?.length ? (
                <NoItems title='Dispenses' />
            ) : (
                <Table width='100%' >
                    <Th >
                        <Td w='20%' noTooltip text='Date' />
                        <Td w='20%' noTooltip text='Machine' />
                        <Td w='20%' noTooltip text='From Tank' />
                        <Td w='20%' noTooltip text='To Tank' />
                        <Td w='20%' noTooltip text='Fuel Type' />
                        <Td w='20%' noTooltip text='Amount' />
                        <Td w='20%' noTooltip text='Cost' />
                        <Td w='20%' noTooltip text='Employee' />
                        <Td w='20%' noTooltip text='Odometer' />
                        <Td w='20%' noTooltip text='Engine Hours' />
                    </Th>
                    {dispenses?.data.map((d) => {
                        return (
                            <Tr key={d.id}>
                                <Td w='20%' text={formatDateWithTime(d.dispensedAt, true)} />
                                <Td w='20%' text={d.machine?.name} />
                                <Td w='20%' text={d.fromFuelTank?.name || '/'} />
                                <Td w='20%' text={d.toFuelTank?.name || '/'} />
                                <Td w='20%' text={d.fuelType?.name || '/'} />
                                <Td w='20%' text={formatNumbersForDisplay(d.quantity) || '/'} />
                                <Td w='20%' text={formatNumbersForDisplay(d.cost) + ' GH₵'} />
                                <Td w='20%' text={d?.user ? (d?.user?.firstName + ' ' + d?.user?.lastName) : '/'} />
                                <Td w='20%' text={d.odometer || '/'} />
                                <Td w='20%' text={d.engineHours || '/'} />
                            </Tr>
                        )
                    })}
                </Table>
            )}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(dispenses?.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}